import { Component, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Person } from '../../data/person';
import { AssessmentService } from '../../services/assessment.service';
import { LookupDataService } from '../../services/lookup-data.service';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';
import { IFormTypes } from '../../data/form-types';
import { FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { ApplicantDetails } from '../../data/applicant-details';
import { MatDialog } from '@angular/material/dialog';
import { PersonDialogComponent } from '../../components/person-dialog/person-dialog.component';
import { LookupItem } from '../../models/lookup-item';
import { Observable } from 'rxjs';
import { IFormComponent } from '../../models/i-form-component';
import { ApplicantText } from '../../models/applicant-text';
import { IVisaType } from '../../data/visa-type';

export class OtherFamilyDetails {
  otherApplicants: boolean = false;
  personList: Person[] = [];
}


@Component({
  selector: 'app-other-family',
  templateUrl: './other-family.component.html',
  styleUrl: './other-family.component.scss'
})
export class OtherFamilyComponent implements OnInit, IFormComponent {

  @Input()model!: InitialAssessmentForm;
  @Input()formTypes!: IFormTypes;
  @Input()titles!: LookupItem[];
  @Input()relationTypes!: LookupItem[];
  @Input()maritalStatuses!: LookupItem[];
  @Input()educationLevels!: LookupItem[];
  @Input()countries!: LookupItem[];
  @Input()visaTypes!: IVisaType[];
  @Output() formReady = new EventEmitter<FormGroup>();

  @ViewChild('familyMembers') familyMembersComponent?: any;
  @ViewChild('nonIncludedChildren') nonIncludedChildrenComponent?: any;
   
  applicantText: ApplicantText;
  selectedForm: any;
  isVevo: any;
  isVevoEmployee: any;
  submitAttempted: boolean = false;


  constructor(private assessmentService: AssessmentService) { 
    this.applicantText = this.assessmentService.applicantText();

  }
  isFormValid(): boolean {
    this.submitAttempted = true;
    const familyMembersValid = this.familyMembersComponent?.otherApplicantsForm?.valid ?? true;
    const nonIncludedChildrenValid = this.nonIncludedChildrenComponent?.nonIncludedChildrenForm?.valid ?? true;
    return familyMembersValid && nonIncludedChildrenValid;
  
  }
  markFormAsTouched(): void {
    if (this.familyMembersComponent?.otherApplicantsForm) {
      this.familyMembersComponent?.otherApplicantsForm.markAllAsTouched();
    }
    if (this.nonIncludedChildrenComponent?.nonIncludedChildrenForm) {
      this.nonIncludedChildrenComponent?.nonIncludedChildrenForm.markAllAsTouched();
    }
  }

  ngOnInit(): void {
    
    this.selectedForm = this.assessmentService.selectedForm();
    this.isVevo = this.assessmentService.isVevo();
    this.isVevoEmployee = this.assessmentService.isVevoEmployee();

  }


}
